import { render, staticRenderFns } from "./AiTips.vue?vue&type=template&id=7d1b43bd&scoped=true"
import script from "./AiTips.vue?vue&type=script&lang=js"
export * from "./AiTips.vue?vue&type=script&lang=js"
import style0 from "./AiTips.vue?vue&type=style&index=0&id=7d1b43bd&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1b43bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d1b43bd')) {
      api.createRecord('7d1b43bd', component.options)
    } else {
      api.reload('7d1b43bd', component.options)
    }
    module.hot.accept("./AiTips.vue?vue&type=template&id=7d1b43bd&scoped=true", function () {
      api.rerender('7d1b43bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/StoryMode/Components/AiBuddy/AiTips.vue"
export default component.exports